import { registerGame } from '../../../game/framework/GamesRegistry';
import { Paintbrush } from 'lucide-react';

registerGame({
  id: 'draw-together',
  displayName: 'DrawTogether',
  shortDescription: 'Collaborative Paint.NET shared sketchpad with chisel brushes & multi-layers.',
  category: 'activity',
  multiplayer: true,
  // Solo mode removed: all sessions are both single AND multiplayer.
  // Others can join anytime, even if the creator started alone.
  solo: false,
  available: true,
  leaderboard: null,
  icon: Paintbrush,
  asset: async () => ({ default: () => null }),
  attribution: {
    text: 'DrawTogether Studio — PsydeChat',
    license: 'MIT',
  },
});
